import { Component, inject, OnInit, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionKeeperService } from '../../services/session-keeper.service';
import { SessionKeeperAction } from '../../models/session-keeper-action.enum';
import { DialogComponent } from '@toevla/ui';

@Component({
    selector: 'tvsk-session-keeper',
    imports: [CommonModule, DialogComponent],
    templateUrl: './session-keeper.component.html',
    styleUrl: './session-keeper.component.css'
})
export class SessionKeeperComponent implements OnInit {
	showPopup = signal(false);
	logout = output();

	readonly #sessionKeeperService = inject(SessionKeeperService);

	ngOnInit() {
		this.#sessionKeeperService.actions$.subscribe((action) => {
			switch (action) {
				case SessionKeeperAction.Idle:
					this.showPopup.set(false);
					break;
				case SessionKeeperAction.Logout:
					this.stopSession();
					break;
				case SessionKeeperAction.Running:
					this.showPopup.set(false);
					break;
				case SessionKeeperAction.ShowPopup:
					this.showPopup.set(true);
					break;
			}
		});
	}

	keepSession() {
		this.showPopup.set(false);
		this.#sessionKeeperService.extendSession();
	}

	stopSession() {
		this.showPopup.set(false);
		this.logout.emit();
	}
}
